import React from 'react';
import { Link } from 'react-router-dom';

import { Urls } from 'js/src/client';

const PageTerms = React.memo(function PageTerms() {
    return (
        <section style={{ marginTop: '140px', marginBottom: '140px' }}>
            <div className="page-content">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                            <h3>Terms of Service</h3>

                            <div className="font-l5 font-l5--regular">
                                Thank you for your interest in Lumen5 Technologies Ltd doing
                                business as Lumen5 (“
                                <strong>Lumen5</strong>,” “<strong>we</strong>,” or “
                                <strong>us</strong>”) and our website at lumen5.com, along with our
                                related websites, networks, applications, mobile applications, and
                                other services provided by us (collectively, the “
                                <strong>Service</strong>”). These Terms of Service are a legally
                                binding contract between you and Lumen5 regarding your use of the
                                Service.
                            </div>

                            <h4 className="mt-l5-48">PLEASE READ THE FOLLOWING TERMS CAREFULLY</h4>

                            <div className="mt-l5-48 font-l5 font-l5--regular">
                                BY CLICKING &quot;I ACCEPT,&quot; OR BY DOWNLOADING, INSTALLING, OR
                                OTHERWISE ACCESSING OR USING THE SERVICE, YOU AGREE THAT YOU HAVE
                                READ AND UNDERSTOOD, AND, AS A CONDITION TO YOUR USE OF THE SERVICE,
                                YOU AGREE TO BE BOUND BY, THE FOLLOWING TERMS AND CONDITIONS,
                                INCLUDING LUMEN5’S PRIVACY POLICY AND ANY ADDITIONAL TERMS AND
                                POLICIES LUMEN5 MAY PROVIDE FROM TIME TO TIME (TOGETHER, THESE
                                &quot;TERMS&quot;). If you are not eligible, or do not agree to the
                                Terms, then you do not have our permission to use the Service. YOUR
                                USE OF THE SERVICE, AND LUMEN5’S PROVISION OF THE SERVICE TO YOU,
                                CONSTITUTES AN AGREEMENT BY LUMEN5 AND BY YOU TO BE BOUND BY THESE
                                TERMS.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                Please read the Lumen5 Privacy Policy (
                                <a href={Urls.PRIVACY}>https://lumen5.com/privacy/</a>) carefully
                                for information relating to our collection, use, storage, disclosure
                                of your personal information. The Lumen5 Privacy Policy is
                                incorporated by this reference into, and made a part of, these
                                Terms.
                            </div>

                            <h4 className="mt-l5-48">1. Lumen5 Service Overview</h4>

                            <div className="font-l5 font-l5--regular">
                                The Service provides a video creation tool that enables users to
                                produce videos, incorporating content including videos, photographs,
                                graphics, music tracks, text, icons, and other types of works (“
                                <strong>Video Content</strong>”).
                            </div>

                            <h4 className="mt-l5-48">2. Eligibility</h4>

                            <div className="font-l5 font-l5--regular">
                                You must be at least 16 years old to use the Service. By agreeing to
                                these Terms, you represent and warrant to us that: (a) you are at
                                least 16 years old; (b) you have not previously been suspended or
                                removed from the Service; and (c) your registration and your use of
                                the Service is in compliance with any and all applicable laws and
                                regulations. If you are an entity, organization, or company, the
                                individual accepting these Terms on your behalf represents and
                                warrants that they have authority to bind you to these Terms and
                                references to you herein (and all of your obligations hereunder)
                                will refer to such entity and any individual using the Service on
                                such entity’s behalf.
                            </div>

                            <h4 className="mt-l5-48">3. Accounts and Registration</h4>

                            <div className="font-l5 font-l5--regular">
                                To access most features of the Service, you must register for an
                                account. When you register for an account, you may be required to
                                provide us with some information about yourself, such as your name,
                                email address, or other contact information. You agree that the
                                information you provide to us is accurate and that you will keep it
                                accurate and up-to-date at all times. When you register, you will be
                                asked to provide a password. You are solely responsible for
                                maintaining the confidentiality of your account and password, and
                                you accept responsibility for all activities that occur under your
                                account. If you believe that your account is no longer secure, then
                                you must immediately notify us at{' '}
                                <a href="mailto:support@lumen5.com">support@lumen5.com</a>.
                            </div>

                            <h4 className="mt-l5-48">4. General Payment Terms</h4>

                            <div className="font-l5 font-l5--regular">
                                Premium features of the Service will require you to pay fees upon
                                registering for the applicable premium service. Before you pay any
                                fees, you will have an opportunity to review and accept the fees
                                that you will be charged. All fees are in U.S. Dollars and are
                                non-refundable. Fees vary based on the plan, with different pricing
                                schemes for individual users and organizations.
                            </div>

                            <h5 className="mt-l5-48">4.1 Price</h5>

                            <div className="font-l5 font-l5--regular">
                                Lumen5 reserves the right to determine pricing for the Service.
                                Lumen5 will make reasonable efforts to keep pricing information
                                published on the website up to date.
                                <div>
                                    We encourage you to check our website periodically for current
                                    pricing information, located here:{' '}
                                    <a href={Urls.PRICING}>https://lumen5.com/pricing/</a>.
                                </div>
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                Lumen5 may change the fees for any feature of the Service, including
                                additional fees or charges, if Lumen5 gives you advance notice of
                                changes before they apply. Lumen5, at its sole discretion, may make
                                promotional offers with different features and different pricing to
                                any of Lumen5’s customers. These promotional offers, unless made to
                                you, will not apply to your offer or these Terms.
                            </div>

                            <h5 className="mt-l5-48">4.2 Authorization</h5>

                            <div className="font-l5 font-l5--regular">
                                You authorize Lumen5 to charge all sums for the orders that you make
                                and any level of Service you select as described in these Terms or
                                published by Lumen5, to the payment method specified in your
                                account. If you pay any fees with a credit card, Lumen5 may seek
                                pre-authorization of your credit card account prior to your purchase
                                to verify that the credit card is valid and has the necessary funds
                                or credit available to cover your purchase.
                            </div>

                            <h5 className="mt-l5-48">
                                4.3 Subscription Service and Cancellation Policy
                            </h5>

                            <div className="font-l5 font-l5--regular">
                                The Service may include automatically recurring payments for
                                periodic charges (“
                                <strong>Subscription Service</strong>”). If you activate a
                                Subscription Service, you authorize Lumen5 to periodically charge,
                                on a going-forward basis and until cancellation of either the
                                recurring payments or your account, all accrued sums on or before
                                the payment due date for the accrued sums. The “
                                <strong>Subscription Billing Date</strong>” is the date when you
                                purchase your first subscription to the Service. For information on
                                the “Subscription Fee”, please see our Pricing page. Your account
                                will be charged automatically on the Subscription Billing Date all
                                applicable fees for the next subscription period. The subscription
                                will continue unless and until you cancel your subscription or we
                                terminate it. You must cancel your subscription before it renews in
                                order to avoid billing of the next periodic Subscription Fee to your
                                account. We will bill the periodic Subscription Fee to the payment
                                method you provide to us during registration (or to a different
                                payment method if you change your payment information). You may
                                cancel the Subscription Service by accessing your account settings
                                at: <a href={Urls.ACCOUNT}>https://lumen5.com/dashboard/account/</a>{' '}
                                or by contacting us at:{' '}
                                <a href="mailto:support@lumen5.com">support@lumen5.com</a>.
                            </div>

                            <h5 className="mt-l5-48">4.4 Delinquent Accounts</h5>

                            <div className="font-l5 font-l5--regular">
                                Lumen5 may suspend or terminate access to the Service for any
                                account for which any amount is due but unpaid. In addition to the
                                amount due for the Service, a delinquent account will be charged
                                with fees or charges that are incidental to any chargeback or
                                collection of any the unpaid amount, including collection fees.
                            </div>

                            <h4 className="mt-l5-48">5. Licenses</h4>

                            <h5>5.1 Permission to Use</h5>

                            <div className="font-l5 font-l5--regular">
                                Subject to your complete and ongoing compliance with these Terms,
                                Lumen5 grants you limited, non-transferable, non-sublicensable,
                                revocable permission to access and use the Service for your
                                personal, internal use during the Term at the level of service for
                                which you have paid all applicable Fees.
                            </div>

                            <h5 className="mt-l5-48">5.2 Restrictions</h5>

                            <div className="font-l5 font-l5--regular">
                                Except and solely to the extent such a restriction is impermissible
                                under applicable law, you may not: (a) reproduce, distribute,
                                publicly display, or publicly perform the Service; (b) make
                                modifications to the Service; or (c) interfere with or circumvent
                                any feature of the Service, including any security or access control
                                mechanism. If you are prohibited under applicable law from using the
                                Service, you may not use it.
                            </div>

                            <h5 className="mt-l5-48">5.3 Feedback</h5>

                            <div className="font-l5 font-l5--regular">
                                If you choose to provide input and suggestions regarding problems
                                with or proposed modifications or improvements to the Service (“
                                <strong>Feedback</strong>”), then you hereby grant Lumen5 an
                                unrestricted, perpetual, irrevocable, non-exclusive, fully-paid,
                                royalty-free right to exploit the Feedback in any manner and for any
                                purpose, including to improve the Service and create other products
                                and services.
                            </div>

                            <h4 className="mt-l5-48">6. Ownership; Proprietary Rights</h4>

                            <div className="font-l5 font-l5--regular">
                                The Service is owned and operated by Lumen5. The visual interfaces,
                                graphics, design, compilation, information, data, computer code
                                (including source code or object code), products, software,
                                services, templates, and all other elements of the Service (“
                                <strong>Materials</strong>”) provided by Lumen5 are protected by
                                intellectual property and other laws. All Materials included in the
                                Service are the property of Lumen5 or its third party licensors.
                                Except as expressly authorized by Lumen5, you may not make use of
                                the Materials. Lumen5 reserves all rights to the Materials not
                                granted expressly in these Terms.
                            </div>

                            <h4 className="mt-l5-48">7. Third Party Terms</h4>

                            <h5>7.1 Third Party Services and Linked Websites</h5>

                            <div className="font-l5 font-l5--regular">
                                Lumen5 provides tools through the Service that enable you to import
                                and export information, including User Content, to and from third
                                party services, including through features that allow you to link
                                your account on Lumen5 with an account on a third party service,
                                such as YouTube or Facebook. By using one of these tools, you agree
                                that Lumen5 may transfer that information to and from the applicable
                                third party service. Third party services are not under Lumen5’s
                                control, and Lumen5 is not responsible for any third party service’s
                                use of your exported information. The Service may also contain links
                                to third party websites. Linked websites are not under Lumen5’s
                                control, and Lumen5 is not responsible for their content.
                            </div>

                            <h5 className="mt-l5-48">7.2 Third Party Software</h5>

                            <div className="font-l5 font-l5--regular">
                                The Service may include or incorporate third party software
                                components that are generally available free of charge under
                                licenses granting recipients broad rights to copy, modify, and
                                distribute those components (“
                                <strong>Third Party Components</strong>”). Although the Service is
                                provided to you subject to these Terms, nothing in these Terms
                                prevents, restricts, or is intended to prevent or restrict you from
                                obtaining Third Party Components under the applicable third party
                                licenses or to limit your use of Third Party Components under those
                                third party licenses.
                            </div>

                            <h4 className="mt-l5-48">8. Content</h4>

                            <h5>8.1 Video Content Generally</h5>

                            <div className="font-l5 font-l5--regular">
                                Certain features of the Service may allow users to view, select,
                                suggest, recommend, display, remix, and utilize Video Content while
                                producing videos. Lumen5 does not make any guarantees about any
                                Video Content made available through the Service. It is your
                                responsibility to ensure that you have all necessary rights to use
                                any Video Content.
                            </div>

                            <h5 className="mt-l5-48">8.2 Premium Media</h5>

                            <div className="font-l5 font-l5--regular">
                                Lumen5 may make available Video Content from third party partners.
                                Use of any partner media is covered by their respective agreements.
                            </div>

                            <div className="mt-l5-24 font-l5 font-l5--regular">
                                <strong>Content Provided by Footage Firm Inc.</strong>
                                <br />
                                Use of Content provided by Footage Firm, Inc., the operator of
                                storyblocks.com, videoblocks.com, graphicstock.com, and
                                audioblocks.com, is covered by the{' '}
                                <Link to={Urls.TERMS_VIDEOBLOCKS}>
                                    Footage Firm Inc. End User License Agreement
                                </Link>
                                .
                            </div>

                            <div className="mt-l5-24 font-l5 font-l5--regular">
                                <strong>Content Provided by Tenor Inc.</strong>
                                <br />
                                Use of Content provided by Tenor, Inc., the operator of tenor.com,
                                is covered by the{' '}
                                <a href="https://tenor.com/legal-terms">
                                    Tenor Inc. Terms of Service
                                </a>
                                .
                            </div>

                            <div className="mt-l5-24 font-l5 font-l5--regular">
                                <strong>Content Provided by Getty Images, Inc.</strong>
                                <br />
                                Use of Content provided by Getty Images, Inc., the operator of
                                gettyimages.com, is covered by the{' '}
                                <Link to={Urls.TERMS_GETTY}>
                                    Getty Images, Inc. Additional Terms of Service
                                </Link>
                                .
                            </div>

                            <div className="mt-l5-24 font-l5 font-l5--regular">
                                <strong>Content Provided by Shutterstock, Inc.</strong>
                                <br />
                                Use of Content provided by Shutterstock, Inc., the operator of
                                shutterstock.com, is covered by the{' '}
                                <Link to={Urls.TERMS_SHUTTERSTOCK}>
                                    Shutterstock, Inc. Additional Terms of Service
                                </Link>
                                .
                            </div>

                            <div className="mt-l5-24 font-l5 font-l5--regular">
                                <strong>Content Provided by De-Identification Inc.</strong>
                                <br />
                                Use of Content provided by De-Identification Inc. (D-ID), the
                                operator of d-id.com, is covered by the{' '}
                                <a href="https://www.d-id.com/eua/">D-ID End User Agreement</a>.
                            </div>

                            <h5 className="mt-l5-48">8.3 User Content Generally</h5>

                            <div className="font-l5 font-l5--regular">
                                Certain features of the Service may permit users to upload content
                                to the Service, including videos, photographs, graphics, music
                                tracks, text, icons, and other types of works (“
                                <strong>User Content</strong>”) and to publish User Content on the
                                Service.{' '}
                                <strong>
                                    You retain any copyright and other proprietary rights that you
                                    may hold in the User Content that you post to the Service.
                                </strong>{' '}
                                <em>
                                    Nevertheless, we need certain permission from you in order to
                                    provide the Service.
                                </em>
                            </div>

                            <h5 className="mt-l5-48">8.4 Limited License Grant to Lumen5</h5>

                            <div className="font-l5 font-l5--regular">
                                By providing User Content to or via the Service, you grant Lumen5 a
                                worldwide, non-exclusive, royalty-free, fully paid right and license
                                (with the right to sublicense) to host, store, transfer, display,
                                perform, reproduce, modify, adapt, create derivative works of,
                                reformat, translate, excerpt (in whole or in part), publish and
                                distribute your User Content, in whole or in part, in any media
                                formats and through any media channels now known or hereafter
                                developed, for the purposes of providing the Service. Lumen5 will
                                not sell, publish, or publicly distribute User Content provided to
                                the Service without permission from you.
                            </div>

                            <h5 className="mt-l5-48">8.5 Limited License Grant to Other Users</h5>

                            <div className="font-l5 font-l5--regular">
                                User Content you provide to the Service will be restricted to your
                                account and will not be shared to other Users of the Service except
                                as requested by you. If you request User Content to be made
                                available to other Users of the Service, you grant those Users a
                                non-exclusive license to access and use that User Content as
                                permitted by these Terms and the functionality of the Service.
                            </div>

                            <h5 className="mt-l5-48">
                                8.6 User Content Representations and Warranties
                            </h5>

                            <div className="font-l5 font-l5--regular">
                                Lumen5 disclaims any and all liability in connection with User
                                Content. You are solely responsible for your User Content and the
                                consequences of providing User Content via the Service. By providing
                                User Content via the Service, you affirm, represent, and warrant
                                that:
                                <ol type="a">
                                    <li>
                                        you are the creator and owner of the User Content, or have
                                        the necessary licenses, rights, consents, and permissions to
                                        authorize Lumen5 and users of the Service to use and
                                        distribute your User Content as necessary to exercise the
                                        licenses granted by you in this Section, in the manner
                                        contemplated by Lumen5, the Service, and these Terms;
                                    </li>
                                    <li>
                                        your User Content, and the use of your User Content as
                                        contemplated by these Terms, does not and will not: (i)
                                        infringe, violate, or misappropriate any third party right,
                                        including any copyright, trademark, patent, trade secret,
                                        moral right, privacy right, right of publicity, or any other
                                        intellectual property or proprietary right; (ii) slander,
                                        defame, libel, or invade the right of privacy, publicity or
                                        other property rights of any other person; or (iii) cause
                                        Lumen5 to violate any law or regulation; and
                                    </li>
                                    <li>
                                        your User Content could not be deemed by a reasonable person
                                        to be objectionable, profane, indecent, pornographic,
                                        harassing, threatening, embarrassing, hateful, or otherwise
                                        inappropriate.
                                    </li>
                                </ol>
                            </div>

                            <div className="font-l5 font-l5--regular">
                                Notwithstanding the foregoing, we reserve the right to screen,
                                remove, edit, or block any User Content we find in violation of the
                                Terms or that we find, in our sole discretion to be otherwise
                                objectionable, at our sole discretion.
                            </div>

                            <h5 className="mt-l5-48">8.7 User Content Disclaimer</h5>

                            <div className="font-l5 font-l5--regular">
                                We are under no obligation to edit or control User Content that you
                                or other users upload or publish, and will not be in any way
                                responsible or liable for User Content. Lumen5 may, however, at any
                                time and without prior notice, screen, remove, edit, or block any
                                User Content that in our sole judgment violates these Terms or is
                                otherwise objectionable. You understand that when using the Service
                                you may be exposed to User Content from a variety of sources and
                                acknowledge that User Content may be inaccurate, offensive,
                                indecent, or objectionable. You agree to waive, and do waive, any
                                legal or equitable right or remedy you have or may have against
                                Lumen5 with respect to User Content. If notified by a user or
                                content owner that User Content allegedly does not conform to these
                                Terms, we may investigate the allegation and determine in our sole
                                discretion whether to remove the User Content, which we reserve the
                                right to do at any time and without notice. For clarity, Lumen5 does
                                not permit copyright-infringing activities on the Service.
                            </div>

                            <h5 className="mt-l5-48">8.8 Monitoring Content</h5>

                            <div className="font-l5 font-l5--regular">
                                Lumen5 does not control and does not have any obligation to monitor:
                                (a) User Content; (ii) any content made available by third parties;
                                or (iii) the use of the Service by its users. You acknowledge and
                                agree that Lumen5 reserves the right to, and may from time to time,
                                monitor any and all information transmitted or received through the
                                Service for operational and other purposes. If at any time Lumen5
                                chooses to monitor the content, Lumen5 still assumes no
                                responsibility or liability for content or any loss or damage
                                incurred as a result of the use of content. During monitoring,
                                information may be examined, recorded, copied, and used in
                                accordance with our Privacy Policy.
                            </div>

                            <h4 className="mt-l5-48">9. Prohibited Conduct</h4>

                            <div className="font-l5 font-l5--regular">
                                BY USING THE SERVICE YOU AGREE NOT TO:
                                <ul>
                                    <li>
                                        use the Service for any illegal purpose or in violation of
                                        any local, state, national, or international law;
                                    </li>
                                    <li>
                                        violate, or encourage others to violate, any right of a
                                        third party, including by infringing or misappropriating any
                                        third party intellectual property right;
                                    </li>
                                    <li>
                                        interfere with security-related features of the Service,
                                        including by: (i) disabling or circumventing features that
                                        prevent or limit use or copying of any content; (ii) reverse
                                        engineering or otherwise attempting to discover the source
                                        code of any portion of the Service except to the extent that
                                        the activity is expressly permitted by applicable law; or
                                        (iii) hacking, password “mining” or using any other
                                        illegitimate means of interference;
                                    </li>
                                    <li>
                                        modify or create derivatives of any part of the Service;
                                    </li>
                                    <li>
                                        interfere with the operation of the Service or any user’s
                                        enjoyment of the Service, including by: (i) uploading or
                                        otherwise disseminating any virus, adware, spyware, worm, or
                                        other malicious code; (ii) making any unsolicited offer or
                                        advertisement to another user of the Service; (iii)
                                        collecting personal information about another user or third
                                        party without consent; or (iv) interfering with or
                                        disrupting any network, equipment, or server connected to or
                                        used to provide the Service;
                                    </li>
                                    <li>
                                        perform any fraudulent activity including impersonating any
                                        person or entity, claiming a false affiliation, accessing
                                        any other Service account without permission, or falsifying
                                        your age or date of birth;
                                    </li>
                                    <li>
                                        take action that imposes an unreasonable or
                                        disproportionately large load on the infrastructure of the
                                        Service of Lumen5’s systems or networks, or any systems or
                                        networks connected to the Service or Lumen5;
                                    </li>
                                    <li>
                                        sell or otherwise transfer the access granted under these
                                        Terms or any Materials (as defined in Section 6) or any
                                        right or ability to view, access, or use any Materials; or
                                    </li>
                                    <li>
                                        attempt to do any of the acts described in this Section 9 or
                                        assist or permit any person in engaging in any of the acts
                                        described in this Section 9.
                                    </li>
                                </ul>
                            </div>

                            <h4 className="mt-l5-48">10. AI</h4>

                            <h5>10.1 License Grant for Improving AI</h5>

                            <div className="font-l5 font-l5--regular">
                                To help us continually improve and enhance our AI features and
                                provide you with a better experience, we may use your User Content
                                to help train our AI models. This process assists our system in
                                learning and adapting. We commit to using this data with utmost
                                responsibility and exclusively to improve our Service.
                            </div>

                            <h5 className="mt-l5-48">10.2 Ownership of AI-Generated Content</h5>

                            <div className="font-l5 font-l5--regular">
                                Content produced by our AI on your behalf remains your property. By
                                using the AI functionalities, you grant Lumen5 a limited,
                                non-exclusive license to access, reproduce, distribute, and display
                                the AI-generated content solely for the purpose of providing the
                                Service.
                            </div>

                            <h5 className="mt-l5-48">10.3 Liability for AI-Generated Content</h5>

                            <div className="font-l5 font-l5--regular">
                                Lumen5 assumes no liability for content produced by the AI.
                                Customers are responsible for verifying the accuracy,
                                appropriateness, and legality of any AI-generated content and for
                                any consequences arising from its use.
                            </div>

                            <h5 className="mt-l5-48">10.4 Restricted Uses</h5>

                            <div className="font-l5 font-l5--regular">
                                Users must not utilize Lumen5’s AI to:
                                <ul>
                                    <li>
                                        Mislead anyone that the content generated by AI is
                                        human-generated;
                                    </li>
                                    <li>
                                        Provide medical, legal, or financial advice, or content
                                        related to the treatment, prevention, diagnosis, or
                                        transmission of diseases;
                                    </li>
                                    <li>Generate political content for electoral campaigns;</li>
                                    <li>
                                        Produce spam, ransomware, viruses, or other malicious
                                        software;
                                    </li>
                                    <li>
                                        Produce nudity, shocking content, obscene gestures, bodily
                                        fluids, or other inappropriate subjects;
                                    </li>
                                    <li>
                                        Produce or disseminate information for legal or justice
                                        administration purposes;
                                    </li>
                                </ul>
                            </div>

                            <h5 className="mt-l5-48">10.5 Disclaimer</h5>

                            <div className="font-l5 font-l5--regular">
                                The output produced by our AI is purely machine-generated. Lumen5
                                has not verified the accuracy or appropriateness of this output, and
                                it does not represent Lumen5&apos;s views or opinions. Lumen5 makes
                                no warranties or guarantees regarding the accuracy, completeness, or
                                reliability of the AI output. Lumen5 accepts no liability or
                                responsibility arising from the use, misuse, or reliance on the
                                AI-generated content. We strongly advise users to obtain
                                professional and independent advice before taking any action based
                                on AI-generated content.
                            </div>

                            <h4 className="mt-l5-48">11. Copyright</h4>

                            <h5>11.1 Digital Millennium Copyright Act</h5>

                            <div className="font-l5 font-l5--regular">
                                We comply with the provisions of the Digital Millennium Copyright
                                Act applicable to Internet service providers (17 U.S.C. §512, as
                                amended). If you have an intellectual property rights-related
                                complaint about material posted on the Service, you may contact our
                                Designated Agent at the following address:
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                Lumen5 Technologies Ltd
                                <br />
                                ATTN: Legal Department (Copyright Notification)
                                <br />
                                {SERVER?.COMPANY_ADDRESS?.LINE1}
                                <br />
                                {SERVER?.COMPANY_ADDRESS?.LINE2}
                                <br />
                                Email: <a href="mailto:dmca@lumen5.com">dmca@lumen5.com</a>
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                Any notice alleging that materials hosted by or distributed through
                                the Service infringe intellectual property rights must include the
                                following information:
                                <ul>
                                    <li>
                                        an electronic or physical signature of the person authorized
                                        to act on behalf of the owner of the copyright or other
                                        right being infringed;
                                    </li>
                                    <li>
                                        a description of the copyrighted work or other intellectual
                                        property that you claim has been infringed;
                                    </li>
                                    <li>
                                        a description of the material that you claim is infringing
                                        and where it is located on the Service;
                                    </li>
                                    <li>your address, telephone number, and email address;</li>
                                    <li>
                                        a statement by you that you have a good faith belief that
                                        the use of the materials on the Service of which you are
                                        complaining is not authorized by the copyright owner, its
                                        agent, or the law; and
                                    </li>
                                    <li>
                                        a statement by you that the above information in your notice
                                        is accurate and that, under penalty of perjury, you are the
                                        copyright or intellectual property owner or authorized to
                                        act on the copyright or intellectual property owner&apos;s
                                        behalf.
                                    </li>
                                </ul>
                            </div>

                            <h5 className="mt-l5-48">11.2 Repeat Infringers</h5>

                            <div className="font-l5 font-l5--regular">
                                It is Lumen5’s policy to promptly terminate the accounts of users
                                that are determined by Lumen5 to be repeat infringers.
                            </div>

                            <h4 className="mt-l5-48">12. Modification of these Terms</h4>

                            <div className="font-l5 font-l5--regular">
                                We reserve the right to change these Terms on a going-forward basis
                                at any time. Please check these Terms periodically for changes.
                                Modifications will become effective upon the earlier of (a) your
                                acceptance of the modified Terms, (b) your use of the Service with
                                actual knowledge of the modified Terms, or (c) thirty (30) days
                                following our publication of the modified Terms through the Service.
                                Except as expressly permitted in this Section 12, these Terms may be
                                amended only by a written agreement signed by authorized
                                representatives of the parties to these Terms. Disputes arising
                                under these Terms will be resolved in accordance with the version of
                                these Terms that was in effect at the time the dispute arose.
                            </div>

                            <h4 className="mt-l5-48">
                                13. Term, Termination and Modification of the Service
                            </h4>

                            <h5>13.1 Term</h5>

                            <div className="font-l5 font-l5--regular">
                                These Terms are effective beginning when you accept the Terms or
                                first download, install, access, or use the Service, and ending when
                                terminated as described in Section 13.2.
                            </div>

                            <h5 className="mt-l5-48">13.2 Termination</h5>

                            <div className="font-l5 font-l5--regular">
                                If you violate any provision of these Terms, your authorization to
                                access the Service and these Terms automatically terminate. In
                                addition, Lumen5 may, at its sole discretion, terminate these Terms
                                or your account on the Service, or suspend or terminate your access
                                to the Service, at any time for any reason or no reason, with or
                                without notice. You may terminate your account and these Terms at
                                any time as provided in Section 4.3 or by contacting customer
                                service at{' '}
                                <a href="mailto:support@lumen5.com">support@lumen5.com</a>.
                            </div>

                            <h5 className="mt-l5-48">13.3 Effect of Termination</h5>

                            <div className="font-l5 font-l5--regular">
                                Upon termination of these Terms: (a) your license rights will
                                terminate and you must immediately cease all use of the Service; (b)
                                you will no longer be authorized to access your account or the
                                Service; (c) you must pay Lumen5 any unpaid amount that was due
                                prior to termination; and (d) all payment obligations accrued prior
                                to termination and Sections 5.3, 6, 13.3, 14, 15, 16, 17 and 18 will
                                survive.
                            </div>

                            <h5 className="mt-l5-48">13.4 Modification of the Service</h5>

                            <div className="font-l5 font-l5--regular">
                                Lumen5 reserves the right to modify or discontinue the Service at
                                any time (including by limiting or discontinuing certain features of
                                the Service), temporarily or permanently, without notice to you.
                                Lumen5 will have no liability for any change to the Service or any
                                suspension or termination of your access to or use of the Service.
                                Premium service fees are not refundable.
                            </div>

                            <h4 className="mt-l5-48">14. Indemnity</h4>

                            <div className="font-l5 font-l5--regular">
                                You are responsible for your use of the Service, and you will defend
                                and indemnify Lumen5 and its officers, directors, employees,
                                consultants, affiliates, subsidiaries and agents (together, the “
                                <strong>Lumen5 Entities</strong>”) from and against every claim
                                brought by a third party, and any related liability, damage, loss,
                                and expense, including reasonable attorneys’ fees and costs, arising
                                out of or connected with: (a) your use of, or misuse of, the
                                Service; (b) your violation of any portion of these Terms, any
                                representation, warranty, or agreement referenced in these Terms, or
                                any applicable law or regulation; (c) your violation of any third
                                party right, including any intellectual property right or publicity,
                                confidentiality, other property, or privacy right; or (d) any
                                dispute or issue between you and any third party. We reserve the
                                right, at our own expense, to assume the exclusive defense and
                                control of any matter otherwise subject to indemnification by you
                                (without limiting your indemnification obligations with respect to
                                that matter), and in that case, you agree to cooperate with our
                                defense of those claims.
                            </div>

                            <h4 className="mt-l5-48">15. Disclaimers; No Warranties</h4>

                            <div className="font-l5 font-l5--regular">
                                THE SERVICE AND ALL MATERIALS AND CONTENT AVAILABLE THROUGH THE
                                SERVICE ARE PROVIDED “AS IS” AND ON AN “AS AVAILABLE” BASIS. LUMEN5
                                DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED,
                                RELATING TO THE SERVICE AND ALL MATERIALS AND CONTENT AVAILABLE
                                THROUGH THE SERVICE, INCLUDING: (A) ANY IMPLIED WARRANTY OF
                                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, QUIET
                                ENJOYMENT, OR NON-INFRINGEMENT; AND (B) ANY WARRANTY ARISING OUT OF
                                COURSE OF DEALING, USAGE, OR TRADE. LUMEN5 DOES NOT WARRANT THAT THE
                                SERVICE OR ANY PORTION OF THE SERVICE, OR ANY MATERIALS OR CONTENT
                                OFFERED THROUGH THE SERVICE, WILL BE UNINTERRUPTED, SECURE, OR FREE
                                OF ERRORS, VIRUSES, OR OTHER HARMFUL COMPONENTS, AND LUMEN5 DOES NOT
                                WARRANT THAT ANY OF THOSE ISSUES WILL BE CORRECTED.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU
                                FROM THE SERVICE OR LUMEN5 ENTITIES OR ANY MATERIALS OR CONTENT
                                AVAILABLE THROUGH THE SERVICE WILL CREATE ANY WARRANTY REGARDING ANY
                                OF THE LUMEN5 ENTITIES OR THE SERVICE THAT IS NOT EXPRESSLY STATED
                                IN THESE TERMS. WE ARE NOT RESPONSIBLE FOR ANY DAMAGE THAT MAY
                                RESULT FROM THE SERVICE AND YOUR DEALING WITH ANY OTHER SERVICE
                                USER. YOU UNDERSTAND AND AGREE THAT YOU USE ANY PORTION OF THE
                                SERVICE AT YOUR OWN DISCRETION AND RISK, AND THAT WE ARE NOT
                                RESPONSIBLE FOR ANY DAMAGE TO YOUR PROPERTY (INCLUDING YOUR COMPUTER
                                SYSTEM OR MOBILE DEVICE USED IN CONNECTION WITH THE SERVICE) OR ANY
                                LOSS OF DATA, INCLUDING USER CONTENT.
                            </div>

                            <div className="font-l5 font-l5--regular">
                                HOWEVER, LUMEN5 DOES NOT DISCLAIM ANY WARRANTY OR OTHER RIGHT THAT
                                LUMEN5 IS PROHIBITED FROM DISCLAIMING UNDER APPLICABLE LAW.
                            </div>

                            <h4 className="mt-l5-48 mt-l5-16">16. Limitation of Liability</h4>

                            <div className="font-l5 font-l5--regular">
                                TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL THE LUMEN5
                                ENTITIES BE LIABLE TO YOU FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
                                CONSEQUENTIAL OR PUNITIVE DAMAGES (INCLUDING DAMAGES FOR LOSS OF
                                PROFITS, GOODWILL, OR ANY OTHER INTANGIBLE LOSS) ARISING OUT OF OR
                                RELATING TO YOUR ACCESS TO OR USE OF, OR YOUR INABILITY TO ACCESS OR
                                USE, THE SERVICE OR ANY MATERIALS OR CONTENT ON THE SERVICE, WHETHER
                                BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), STATUTE,
                                OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT ANY LUMEN5 ENTITY HAS
                                BEEN INFORMED OF THE POSSIBILITY OF DAMAGE.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                TO THE FULLEST EXTENT PERMITTED BY LAW, THE AGGREGATE LIABILITY OF
                                THE LUMEN5 ENTITIES TO YOU FOR ALL CLAIMS ARISING OUT OF OR RELATING
                                TO THE USE OF OR ANY INABILITY TO USE ANY PORTION OF THE SERVICE OR
                                OTHERWISE UNDER THESE TERMS, WHETHER IN CONTRACT, TORT, OR
                                OTHERWISE, IS LIMITED TO THE GREATER OF: (A) THE AMOUNT YOU HAVE
                                PAID TO LUMEN5 FOR ACCESS TO AND USE OF THE SERVICE IN THE 12 MONTHS
                                PRIOR TO THE EVENT OR CIRCUMSTANCE GIVING RISE TO CLAIM; OR (B)
                                $100.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                EACH PROVISION OF THESE TERMS THAT PROVIDES FOR A LIMITATION OF
                                LIABILITY, DISCLAIMER OF WARRANTIES, OR EXCLUSION OF DAMAGES IS
                                INTENDED TO AND DOES ALLOCATE THE RISKS BETWEEN THE PARTIES UNDER
                                THESE TERMS. THIS ALLOCATION IS AN ESSENTIAL ELEMENT OF THE BASIS OF
                                THE BARGAIN BETWEEN THE PARTIES. EACH OF THESE PROVISIONS IS
                                SEVERABLE AND INDEPENDENT OF ALL OTHER PROVISIONS OF THESE TERMS.
                                THE LIMITATIONS IN THIS SECTION 16 WILL APPLY EVEN IF ANY LIMITED
                                REMEDY FAILS OF ITS ESSENTIAL PURPOSE.
                            </div>

                            <h4 className="mt-l5-48">17. Arbitration</h4>

                            <div className="font-l5 font-l5--regular">
                                Notwithstanding anything contained herein, you agree that any legal
                                disputes arising out of or relating to these Terms of Service or the
                                Services shall be submitted to binding arbitration in Vancouver,
                                British Columbia, Canada. Any judgment on the award by the
                                arbitrator may be entered in a court having jurisdiction thereof.
                                You agree that any claim, action or proceeding arising out of or
                                related to these Terms of Service or the Services must be brought in
                                your individual capacity, and not as a plaintiff or class member in
                                any purported representative or class proceeding. The arbitrator may
                                not consolidate more than one person’s claims. YOU ACKNOWLEDGE THAT
                                YOU ARE WAIVING THE RIGHT TO A TRIAL BY JURY OR PARTICIPATE AS A
                                PLAINTIFF OR CLASS MEMBER IN A CLASS ACTION OR REPRESENTATIVE
                                PROCEEDING.
                            </div>

                            <h4 className="mt-l5-48">18. General Terms</h4>

                            <div className="font-l5 font-l5--regular">
                                These Terms, together with the Privacy Policy and any other
                                agreements expressly incorporated by reference into these Terms, are
                                the entire and exclusive understanding and agreement between you and
                                Lumen5 regarding your use of the Service. You may not assign or
                                transfer these Terms or your rights under these Terms, in whole or
                                in part, by operation of law or otherwise, without our prior written
                                consent. We may assign these Terms at any time without notice or
                                consent. The failure to require performance of any provision will
                                not affect our right to require performance at any other time after
                                that, nor will a waiver by us of any breach or default of these
                                Terms, or any provision of these Terms, be a waiver of any
                                subsequent breach or default or a waiver of the provision itself.
                                Use of section headers in these Terms is for convenience only and
                                will not have any impact on the interpretation of any provision.
                                Throughout these Terms the use of the word “including” means
                                “including but not limited to”. If any part of these Terms is held
                                to be invalid or unenforceable, the unenforceable part will be given
                                effect to the greatest extent possible, and the remaining parts will
                                remain in full force and effect.
                            </div>

                            <h5 className="mt-l5-48">18.1 Governing Law</h5>

                            <div className="font-l5 font-l5--regular">
                                These Terms are governed by the laws of the Province of British
                                Columbia without regard to conflict of law principles. You and
                                Lumen5 submit to the personal and exclusive jurisdiction of the
                                provincial courts and federal courts located within Vancouver,
                                British Columbia for resolution of any lawsuit or court proceeding
                                permitted under these Terms.
                            </div>

                            <h5 className="mt-l5-48">18.2 Consent to Electronic Communications</h5>

                            <div className="font-l5 font-l5--regular">
                                By using the Service, you consent to receiving certain electronic
                                communications from us as further described in our Privacy Policy.
                                Please read our Privacy Policy to learn more about our electronic
                                communications practices. You agree that any notices, agreements,
                                disclosures, or other communications that we send to you
                                electronically will satisfy any legal communication requirements,
                                including that those communications be in writing.
                            </div>

                            <h5 className="mt-l5-48">18.3 Contact Information</h5>

                            <div className="font-l5 font-l5--regular">
                                The Service is offered by Lumen5 Technologies Ltd located at{' '}
                                {SERVER?.COMPANY_ADDRESS?.LINE1}, {SERVER?.COMPANY_ADDRESS?.LINE2}.
                                You may contact us by sending correspondence to that address or by
                                emailing us at{' '}
                                <a href="mailto:support@lumen5.com">support@lumen5.com</a> . You can
                                access a copy of these Terms by clicking here:{' '}
                                <Link to={Urls.TERMS}>https://lumen5.com/terms/</Link>
                            </div>

                            <h5 className="mt-l5-48">18.4 International Use</h5>

                            <div className="font-l5 font-l5--regular">
                                The Service is intended for visitors located within Canada and the
                                United States. We make no representation that the Service is
                                appropriate or available for use outside of Canada and the United
                                States. Access to the Service from countries or territories or by
                                individuals where such access is illegal is prohibited.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>This document was last updated on August 6, 2024.</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
});

export default PageTerms;
